import { PropsWithChildren, useContext } from "react";
import { Navigate } from "react-router-dom";
import { LegacyAuthenticationContext } from "../authentication.context";

export function LegacyRequiresAuthentication({ children }: PropsWithChildren) {
  const token = useContext(LegacyAuthenticationContext).token;
  return token ? children : <Navigate to="/authentication/login" />;
}
